let html = `
<svg><use xlink:href="#sprite-fire"></use></svg>
`

export default html